import Swiper from '../../Component/_Swiper/Library/Swiper';

var swiper = new Swiper('.licence-packages-text-slider', {
    spaceBetween: 30,
    pagination: {
        el: '.swiper-pagination'
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const packageButtons = document.querySelectorAll('.licence-packages-mobile-headline');
    const packages = document.querySelectorAll('.licence-packages-mobile-feature');

    if (packageButtons.length === 0) {
        return;
    }

    if (packages.length === 0) {
        return;
    }

    packageButtons.forEach(button => {
        button.addEventListener('click', function() {
            const targetId = button.id
                .replace('-btn', '')
                .replace(/(^|\-)(\w)/g, (_, separator, char) => char.toUpperCase());

            packageButtons.forEach(btn => btn.classList.remove('licence-packages-mobile-headline--active'));

            button.classList.add('licence-packages-mobile-headline--active');

            packages.forEach(pkg => (pkg.style.display = 'none'));

            const targetPackage = document.getElementById(targetId);

            if (targetPackage) {
                targetPackage.style.display = 'flex';
            }
        });
    });
});
